import React from 'react';
import * as S from './Card.styles';

const Card = ({children}) => {
  return <S.CardContent>{children}</S.CardContent>;
};

export default Card;
